import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin, Row, Col, Typography, Badge, Tag, Image, Rate, Divider, Button, message } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { removeFromCart, updateQuantity, addToCart } from '../store/reducers/cartSlice';

const { Title, Paragraph } = Typography;
const mockProducts = [
  {
    id: 1,
    title: 'Soja alvic',
    price: 650,
    images: [
      '/images/detail-images/detail1.jpg',
      '/images/detail-images/detail111.jpg'
    ],
    availability: true,
    rating: 4,
    description: 'Soja de qualité supérieure récolté à Atakpame.',
    type: 'Grain',
    brand: 'Grenier des plateaux',
    origin: 'Togo',
    sizes: ['25kg', '50kg']
  },
  {
    id: 2,
    title: 'Pomme de terre',
    price: 600,
    images: [
      '/images/detail-images/detail22.webp',
      '/images/detail-images/detail22.webp'
    ],
    availability: true,
    rating: 4,
    description: 'Pommes de terre fraichement récolté dans le Kloto.',
    type: 'Tubercule',
    brand: 'Havels',
    origin: 'Togo',
    sizes: ['25kg', '50kg']
  },
  {
    id: 3,
    title: 'Fruits et legumes',
    price: 900,
    images: [
      '/images/detail-images/detail3.webp',
      '/images/detail-images/detail3.webp'
    ],
    availability: true,
    rating: 4,
    description: 'Fruits et légumes',
    type: 'Fruits et légumes',
    brand: 'Eden',
    origin: 'Togo',
    sizes: ['15kg', '20kg']
  },
  // Ajouter d'autres produits ici si nécessaire
];

const ProductDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.cart);
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  
    const [showSuggestions, setShowSuggestions] = useState(true);
  
    

  useEffect(() => {
    const found = mockProducts.find((p) => p.id === parseInt(id));
    setProduct(found);
    setLoading(false);
  }, [id]);

  if (loading) {
    return <Spin size="large" className="d-block mx-auto my-5" />;
  }

  if (!product) {
    return <Title level={3}>Produit introuvable</Title>;
  }

  const handleAddedTocart = () => {

      dispatch(addToCart({ ...product, quantity: 1 }));
      message.success(`${product.title} ajouté au panier.`);
      navigate(`/cart`)
    };

  return (
    <div className="container-xxl py-5">
      <Row gutter={[24, 24]}>
        <Col xs={24} md={10}>
          <Image.PreviewGroup>
            {/* 400 px au plus, mais jamais plus large que l'écran */}
            <Image width="100%" style={{ maxWidth: 400 }} src={product.images[0]} alt={product.title} />
            <div className="d-flex flex-wrap gap-10 mt-2">
              {product.images.slice(1).map((img, idx) => (
                <Image key={idx} width={80} src={img} alt={`alt-${idx}`} />
              ))}
            </div>
          </Image.PreviewGroup>
        </Col>

        <Col xs={24} md={14}>
          <Title>{product.title}</Title>
          <Rate disabled value={product.rating} />
          <Paragraph className="mt-2 mb-0">
            <strong>Prix :</strong> <Tag color="green">{product.price} XOF / Kg</Tag>
          </Paragraph>
          <Paragraph>
            <strong>Disponibilité :</strong>{' '}
            {product.availability ? (
              <Badge status="success" text="En stock" />
            ) : (
              <Badge status="error" text="Rupture de stock" />
            )}
          </Paragraph>

          <Divider />

          <Paragraph><strong>Description :</strong></Paragraph>
          <Paragraph>{product.description}</Paragraph>

          <Divider />

          <Paragraph>
            <strong>Origine :</strong> {product.origin}
          </Paragraph>
          <Paragraph>
            <strong>Type :</strong> {product.type}
          </Paragraph>
          <Paragraph>
            <strong>Marque :</strong> {product.brand}
          </Paragraph>
          <Paragraph>
            <strong>Conditionnement :</strong> {product.sizes.join(', ')}
          </Paragraph>
          <Divider />
          <Button className="application-button" onClick={() => handleAddedTocart()}>Ajouter au panier</Button>
        </Col>
      </Row> 
    </div>
  );
};

export default ProductDetails;
